<template>
  <div
    class="previewMode bg-red-50 border-4 border-t-red-300"
    :class="{ close: previewMode }"
  >
    <div class="container">
      <div class="previewMode__block">
        <div
          class="previewMode__toggle bg-red-50 border-4 border-b-red-50 border-r-red-300 border-t-red-300 border-l-red-300"
          @click="previewMode = !previewMode"
        >
          <span class="icon icon-down-arrow"></span>
        </div>

        <div class="previewMode__block__left previewInfo">
          <div class="previewInfo__caveat">
            {{ $t('previewModeEnabled') }}
          </div>

          <div class="previewInfo__customer">
            <strong class="email">{{ $member.user.value?.email }}</strong> <small>(id: {{ $member.user.value?.id }})</small>
          </div>
        </div>

        <div class="previewMode__block__right">
          <div class="btn-holder">
            <button
              type="button"
              class="btn primary-color base-2 waves-effect waves-light right"
              @click="$member.adminPreviewLogout(true)"
            >
              <span>{{ $t('exit') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { $member } = useNuxtApp()
const { useCustomCookie } = useCustomTools()

const previewMode = useCustomCookie('previewMode')
</script>

<style lang="scss" scoped>
.previewMode {
  position: fixed;
  bottom: 0;
  z-index: 9999999;
  width: 100%;
  height: 60px;
  background-color: rgba(255, 255, 255, .9);
  box-shadow: 0 -4px 8px 0 rgba(102, 102, 102, .05);
  transform: translate(0, 0);
  transition: all .3s;

  backdrop-filter: blur(6px);

  &.close {
    transform: translate(0, 56px);

    .previewMode {
      &__toggle {
        .icon {
          transform: translate(-50%, 3px) rotate(180deg);
        }
      }
    }
  }

  &__block {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;

    .btn-holder {
      .btn {
        min-width: auto;
        height: 35px;
        line-height: 35px;
      }
    }

    .previewInfo {
      line-height: 1rem;
      &__caveat {
        color: rgb(153 0 0);
        font-size: 11px;
      }
      &__customer {
        font-size: 14px;
        .email {
          font-weight: 600;
        }
      }
    }
  }

  &__toggle {
    position: absolute;
    top: -30px;
    right: 0;
    width: 40px;
    height: 30px;
    background-color: rgba(255, 255, 255, .9);
    box-shadow: 0 -4px 8px 0 rgba(102, 102, 102, .05);
    border-radius: 10px 10px 0 0;
    cursor: pointer;
    .icon {
      position: absolute;
      top: 0;
      left: 50%;
      color: #131313;
      font-size: 21px;
      transform: translate(-50%, 3px) rotate(0deg);
    }
  }
}
</style>
